<template>
  <dialogWrap
      v-if="show"
      v-model="show"
      :title="title"
      :width="width"
      :before-close="closeAuthDialog"
  >
    <div>
      <el-steps
        :active="stepIndex"
        align-center
        style="margin-bottom: 20px"
        finish-status="success"
      >
          <el-step
              v-for="(step, index) in steps"
              :title="step.title"
              :key="index"
          >
          </el-step>
      </el-steps>

      <!-- 填写信息 -->
      <addOrg
        v-if="realStep === 1"
        ref="addOrgRef"
        :orgName="orgName"
        :orgIdCardNum="orgIdCardNum"
        :disabled="disabled"
        @addContractOrgSucc="addContractOrgSucc"
      />

      <!-- 资源授权链接 -->
      <authLink
        :realStep="realStep"
        :orgId="orgId"
        :reNew="reNew"
        v-else-if="realStep === 2 || realStep === 4"
      />

      <!-- 印章列表 -->
      <sealAuthList
        v-else-if="realStep === 3"
        ref="sealAuthListRef"
        :orgId="orgId"
        :reNew="reNew"
        @sealAuthSubmitSucc="checkNextStep()"
      />

      <!-- 授权完成 -->
      <authSucc :orgId="orgId" :reNew="reNew" v-else-if="realStep === 5" />

      <span slot="footer" class="dialog-footer" style="text-align: center">
          <!-- 普通操作栏 包含表单提交、第一次资源授权链接、 选择印章列表 -->
          <div
            class="dialog-footer-normal"
            v-if="realStep === 1 || realStep === 2 || realStep === 3"
          >
            <el-button @click="closeAuthDialog">取消</el-button>
            <el-button type="primary" @click="submit" :loading="btnLoading">下一步</el-button>
          </div>
          <!-- 第二次资源授权链接 需要展示刷新授权状态按钮 -->
          <div class="dialog-footer-auth-verify" v-else-if="realStep === 4">
            <el-button @click="closeAuthDialog">取消</el-button>
            <el-button @click="realStep = 3">上一步</el-button>
            <el-button
              class="refresh-btn"
              type="primary"
              :loading="btnLoading"
              @click="() => {
                btnLoading = true
                checkNextStep().finally(() => {
                  btnLoading = false
                })
              }">
              刷新授权状态
            </el-button>
          </div>
          <!-- 终态 只展示完成按钮 -->
          <div class="dialog-footer-finish" v-else>
            <el-button type="primary" @click="completeAuthorization">完成</el-button>
          </div>
      </span>
    </div>
  </dialogWrap>
</template>

<script>
import { Loading } from 'element-ui'
import { nextStepForContractOrg } from '@/api/domain/organize'
import addOrg from './addOrg'
import authLink from './authLink'
import sealAuthList from './sealAuthList'
import authSucc from './authSucc'

export default {
  name: 'authDialog',
  components: { addOrg, authLink, sealAuthList, authSucc },
  data() {
    return {
      orgName: '',
      orgIdCardNum: '',
      show: false,
      title: '新增印章授权',
      width: '650px',
      stepIndex: 0,
      steps: [
        {
          title: '填写信息',
        },
        {
          title: '选择印章',
        },
        {
          title: '授权印章',
        },
      ],
      realStep: 1,
      btnLoading: false,
      disabled: false,
      orgId: '',
      reNew: 0,
    }
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    showDialog(row) {
      // 新增一个逻辑 当从商品新增页面 携带部分信息进入
      const { orgName = '', orgIdCardNum = '', disabled = false, reNew = 0 } = row || {}
      this.orgName = orgName
      this.orgIdCardNum = orgIdCardNum
      this.show = true
      this.realStep = 1
      this.stepIndex = 0
      this.disabled = disabled
      this.reNew = reNew
      if (row && row.orgId) {
        this.$nextTick(async () => {
          const loading = Loading.service({
            target: '.loading-class',
          })
          this.orgId = row.orgId
          await this.checkNextStep()
          loading.close()
        })
      }
    },
    async checkNextStep() {
      const { code, data } = await nextStepForContractOrg({
        orgId: this.orgId,
        step: this.realStep,
        reNew: this.reNew,
      })
      if (code === 1) {
        this.realStep = data
        // 2资源授权 3选择印章 4授权印章 5印章授权完成
        if (data === 2 || data === 3) {
          this.stepIndex = 1
        } else if (data === 4) {
          this.stepIndex = 2
        } else {
          this.stepIndex = 3
        }
      }
    },
    async submit() {
      this.btnLoading = true
      if (this.realStep === 1) {
        await this.$refs.addOrgRef.submitAddOrg()
      } else if (this.realStep === 2) {
        await this.checkNextStep()
      } else if (this.realStep === 3) {
        await this.$refs.sealAuthListRef.sealAuthSubmit()
      }
      this.btnLoading = false
    },
    addContractOrgSucc(orgId) {
      this.orgId = orgId
      this.checkNextStep()
    },
    closeAuthDialog() {
      this.show = false
      if (this.realStep !== 1) {
        this.$emit('closeAuthDialog')
      }
    },
    completeAuthorization() {
      this.show = false
      this.$emit('closeAuthDialog')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__footer {
  text-align: center;
}
.dialog-footer-normal {
  margin-top: 20px;
}
.dialog-footer-auth-verify {
  white-space: nowrap;
}
.refresh-btn {
  min-width: 145px;
}
</style>
